<div class="support flex flex-align-center flex-justify-center"><support-content></support-content></div>